export const ACCESS_TOKEN_KEY = 'webcatalog_auth_access_token';
export const ACCESS_TOKEN_UPDATED_AT =
  'webcatalog_auth_access_token_updated_at';
/**
 * Cookie that holds the PKCE verifier between `getLoginUrlAsync` and the
 * callback handler's code-exchange step. Path-scoped to the callback so it
 * isn't sent on unrelated requests.
 */
export const CODE_VERIFIER_KEY = 'code_verifier';
/** The API reads and writes the same cookie; keep the name in sync with its REFRESH_TOKEN_COOKIE_KEY. */
export const REFRESH_TOKEN_COOKIE_KEY = 'webcatalog_auth_refresh_token';
